import { isTouch } from "../core-modules/utils";
import styled from "styled-components";

const LozengeButton = styled.button`
  align-items: center;
  background-color: ${(props) => {
    return props.theme.colors.background;
  }};
  border-color: ${(props) => {
    return props.theme.colors.foreground;
  }};
  border-radius: 9999px;
  border-style: solid;
  border-width: ${(props) => {
    return props.borderWidth || "2px";
  }};
  color: ${(props) => {
    return props.theme.colors.foreground;
  }};
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  font-family: ${(props) => props.theme.fonts.bold};
  height: ${(props) => {
    return props.height || "72px";
  }};
  justify-content: center;
  letter-spacing: 2px;
  padding-left: ${(props) => {
    return props.noPadding ? "0" : "52px";
  }};
  padding-right: ${(props) => {
    return props.noPadding ? "0" : "52px";
  }};
  position: relative;
  text-decoration: none;
  text-transform: uppercase;
  ${(props) => {
    if (props.width) {
      return `width: ${props.width};`;
    }
  }}

  &::after {
    align-items: center;
    background-color: ${(props) => {
      return props.theme.colors.foreground;
    }};
    border-radius: 9999px;
    color: ${(props) => {
      return props.theme.colors.background;
    }};
    content: "${(props) => {
      return typeof props.children === "string" ? props.children : "";
    }}";
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: opacity 200ms;
    width: ${(props) => {
      return props.width || "100%";
    }};
    z-index: 0;
  }

  ${(props) => {
    if (props.small) {
      return `
        height: 47px;
        padding-left: ${props.noPadding ? "0" : "22px"};
        padding-right: ${props.noPadding ? "0" : "22px"};
      `;
    }
  }}

  ${(props) => {
    if (!isTouch() && !props.disabled) {
      return `
        &:hover {
          &::after {
            opacity: 1;
          }
        }
      `;
    }
  }}

  ${(props) => {
    if (props.disabled) {
      return `
        pointer-events: none;
        opacity: 0.5;
      `;
    }
  }}

  @media (max-width: 640px) {
    background-color: ${(props) => {
      return props.invertOnMobile
        ? props.theme.colors.foreground
        : props.theme.colors.background;
    }};
    color: ${(props) => {
      return props.invertOnMobile
        ? props.theme.colors.background
        : props.theme.colors.foreground;
    }};
  }
`;

const LozengeButtonComponent = ({
  invertOnMobile = true,
  noPadding = false,
  ...props
}) => (
  <LozengeButton
    invertOnMobile={invertOnMobile}
    noPadding={noPadding}
    {...props}
  />
);

export default LozengeButtonComponent;
